import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EmailTypeForm from '../../../components/forms/EmailTypeForm';
import { useEmailTypeApi } from '../../../hooks/useEmailTypeApi';
import { useNavigate } from 'react-router-dom';
import { EmailTypeDTO } from '../../../services/apiClient';

const EmailTypeCreate: React.FC = () => {
  const { create, isLoading } = useEmailTypeApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Email Types', href: '/admin/emailtypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: EmailTypeDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/emailtypes');
    } catch (error) {
      console.error('Error creating EmailType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/emailtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.EmailType.Edit"
    >
      <EmailTypeForm
        initialValues={{} as EmailTypeDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/emailtypes')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default EmailTypeCreate;
